import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>(() =>
  createStyles({
    font: {
      fontSize: 12,
      fontWeight: 600,
    },
  }),
);
